import type { HTMLAttributes } from "react";
import { cn } from "../../lib/cn";

// Karte nach CI: weiß auf Papier, Rahmen in Linie, großer Radius.
export function Card({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
  return <div className={cn("rounded-lg border border-line bg-card p-6", className)} {...props} />;
}

export function CardTitle({ className, ...props }: HTMLAttributes<HTMLHeadingElement>) {
  return <h2 className={cn("text-md text-ink", className)} {...props} />;
}
